// extracted by mini-css-extract-plugin
export default {"card":"FleetList_card__KdIo1","image":"FleetList_image__oBv0L","title":"FleetList_title__-1hpP","text":"FleetList_text__GC6gs"};